import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  boundariesSet,
  objectNotEmpty,
  concatenateBoundariesByname
} from '../../../utilities/helpers';

import { boundariesCriteria, organisationTabCriteria, mobileAppCriteria } from '../../../utilities/epic-helpers';

import saveAs from 'file-saver';

import {
  DOWNLOAD_BRAND_AFFINITY_INSIGHTS,
  DOWNLOAD_BRAND_AFFINITY_INSIGHTS_SUCCESS,
  DOWNLOAD_BRAND_AFFINITY_INSIGHTS_FAILURE,
} from '../../constants';


const downloadBrandAffinity = (action$, state$) =>
  action$.pipe(
    ofType(DOWNLOAD_BRAND_AFFINITY_INSIGHTS),
    switchMap(action =>
      ajax({
        url:`${state$.value.auth.server}/report/brand-affinity/${action.csvType}/download?${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }${
            action.csvType === 'top-pois'
            ? state$.value.brandAffinity.currentTopPoisTab === 'brand_affinity'
              ? `&brand=${
                state$.value.brandAffinity.brandAffinityTopPoiBrandOption !== null
                ? state$.value.brandAffinity.brandAffinityTopPoiBrandOption.value
                :''
              }`
              : `&category=${
                state$.value.brandAffinity.brandAffinityTopPoiCategoryOption !== null
                ? encodeURIComponent(state$.value.brandAffinity.brandAffinityTopPoiCategoryOption.value)
                : ''
              }`

            : ''
          }${
            objectNotEmpty(state$.value.insightsCriteria.baseline) === true
            ? `&baseline=${state$.value.insightsCriteria.baseline.value}`
            : ''
          }${
            mobileAppCriteria(state$)
          }${
          `&period=${state$.value.brandAffinity.selectedPeriod.value}`
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'text',
        crossDomain: true,
      }).pipe(
        map(response => {
          const blob = new Blob(

            [
              `${response.response}`,
            ],
            { type: 'text/csv' }
          );

          const fileName = `LANDMARKSID_${action.reportType}_${action.fileName}${
            state$.value.insightsCriteria.insightType === 'organisation' &&
              state$.value.insightsCriteria.organisation.label
              ? `_${state$.value.insightsCriteria.organisation.label}`
              : ''
            }${
              state$.value.insightsCriteria &&
                state$.value.insightsCriteria.baseline
              ? `_${state$.value.insightsCriteria.baseline.label}`
              : ``
            }${
            boundariesSet(state$.value.insightsCriteria.adm0) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm0
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm1) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm1
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm2) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm2
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm3) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm3
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm4) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm4
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.poiId) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.poiId
              )}`
              : ''
            }${
              state$.value.brandAffinity &&
                state$.value.brandAffinity.selectedPeriod
              ? `_${state$.value.brandAffinity.selectedPeriod.label}`
              : ``
            }.csv`;


          saveAs(blob, fileName);
          return {
            type: DOWNLOAD_BRAND_AFFINITY_INSIGHTS_SUCCESS,
          };
        }),
        catchError(error =>
          of({
            type: DOWNLOAD_BRAND_AFFINITY_INSIGHTS_FAILURE,
            error,
          })
        )
      )
        )
  );

export default downloadBrandAffinity;
